import { AES } from "crypto-js";
import { secreteKey } from "src/HostName";
import Cookies from "universal-cookie";

export const encryptData = (name, data) => {
  const cookies = new Cookies();
  const cipherText = AES.encrypt(JSON.stringify(data), secreteKey).toString();

  // Set expiry to 20 years from now
  const expires = new Date();
  expires.setFullYear(expires.getDate() + 30);

  cookies.set(name, cipherText, {
    path: "/",
    expires,
    sameSite: "lax", 
    secure: window.location.protocol === "https:",
  });
};
